import React from "react";
import {
    Segment,
    Header,
    Card,
    Image,
    Icon
  } from 'semantic-ui-react';

export default class SocialMediaImages extends React.Component {
  img_viewer = (target, filename) => {
      //this.props.img_viewer(target, filename);
      if (typeof target === 'undefined') {
        console.error('No target provided for image viewer');
        return;
      }
      //console.log('opening viewer for', target, filename)
      //console.log('in viewer', typeof(target))
      const this_viewer = new this.props.viewer(document.getElementById(target), {
          inline: false,
          container: 'modal',
          toolbar: false,
          viewed() {
              this_viewer.zoomTo(1);
          },
      });
  }
  getFileName(urlString) {
    try {
      // 1. Use the URL constructor to parse the string
      const url = new URL(urlString);
      
      // 2. Grab the pathname (e.g., "/path/to/image.png")
      const { pathname } = url;
      
      // 3. Split by "/" and pop the last element
      // This ignores everything after "?" or "#" automatically
      return pathname.split('/').pop().split('.')[0]; // Remove file extension if needed
    } catch (error) {
      //console.error("Invalid URL provided:", error);
      return "";
    }
  }
  toTitleCase(input) {
    if (!input) return "";
    return input
      .replace(/_/g, ' ')        // 1. Replace all underscores with spaces
      .toLowerCase()             // 2. Ensure everything starts lowercase
      .split(' ')                // 3. Split into an array of words
      .map(word => {
        // 4. Capitalize the first letter of each word
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');                // 5. Join words back into a single string
  }
  renderSocialMediaGroups(){
    var groups = Object.keys(this.props.socialMediaLinks)
    return groups.map((group, index) => {
      if (group === 'base_images'){
        return null
      }
      //console.log('rendering group', group)
      //console.log('index', index)
      return(
        <Segment key={index}>
          <Header as='h3' textAlign='center'>{this.toTitleCase(group)}</Header>
          <Card.Group itemsPerRow={4}>
            {this.renderSocialMediaImagesforGroup(this.props.socialMediaLinks[group])}
          </Card.Group>
        </Segment>
      )
    })
  }
  renderSocialMediaImagesforGroup(LinkGroup){
    //console.log('rendering images for group', LinkGroup)
    var groups = Object.keys(LinkGroup)
    return groups.map((link, index) => (
        
        <Card key={index}>
          <Image id={this.getFileName(LinkGroup[link])} src={'https://photodelivery.hommati.com/' + LinkGroup[link]} wrapped ui={false} onClick={() => this.img_viewer(this.getFileName(LinkGroup[link]))}/>
          <Card.Content>
            <Card.Header textAlign='center'>
              {this.toTitleCase(link)}
            </Card.Header>
          </Card.Content>
          <Card.Content extra>
            <a href={'https://photodelivery.hommati.com/' + LinkGroup[link]} target="_blank" rel="noopener noreferrer">
              <Icon name='download' /> Download
            </a>
          </Card.Content>
        </Card>
      )
    )
  }
  render(){
    if (this.props.socialMediaLinks.length === 0){
      return(
        <Segment>
            <Header as='h2' textAlign='center'>No Social Media Links</Header>
        </Segment>
      )
    }
    if (!this.props.paid_status){
      return(
        <Segment>
            <Header as='h2' textAlign='center'>Social Media Links</Header>
            <Header as='h3' textAlign='center'>Pay now to see social media images</Header>
        </Segment>
      )
    }

    return(
      <Segment>
        <Header as='h2' textAlign='center'>Social Media Images</Header>
        {this.renderSocialMediaGroups()}
      </Segment>
    )
  }
}